import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Capture UTM + source tracking from the current URL / referrer.
export function captureTracking(sourcePage) {
	const params = new URLSearchParams(window.location.search);
	const utm = {
		utm_source: params.get("utm_source") || "",
		utm_medium: params.get("utm_medium") || "",
		utm_campaign: params.get("utm_campaign") || "",
		utm_term: params.get("utm_term") || "",
		utm_content: params.get("utm_content") || "",
	};

	const ref = document.referrer || "";
	let leadSource = "Direct";
	if (utm.utm_source) {
		leadSource = utm.utm_source.charAt(0).toUpperCase() + utm.utm_source.slice(1);
	} else if (ref) {
		const r = ref.toLowerCase();
		if (r.includes("google")) leadSource = "Google";
		else if (r.includes("facebook") || r.includes("fb.")) leadSource = "Facebook";
		else if (r.includes("instagram")) leadSource = "Instagram";
		else if (r.includes("linkedin")) leadSource = "LinkedIn";
		else if (r.includes("whatsapp") || r.includes("wa.me")) leadSource = "WhatsApp";
		else if (r.includes("bing") || r.includes("duckduckgo") || r.includes("yahoo")) leadSource = "Organic Search";
		else leadSource = "Referral";
	}

	return {
		...utm,
		lead_source: leadSource,
		source_page: sourcePage || "Homepage",
		landing_page: window.location.pathname + window.location.search,
		referrer: ref,
		device: /Mobi|Android|iPhone/i.test(navigator.userAgent) ? "Mobile" : "Desktop",
	};
}

export async function submitLead(data) {
	const res = await axios.post(`${API}/leads`, data);
	return res.data;
}

export async function submitContact(data) {
	const res = await axios.post(`${API}/leads`, data);
	return res.data;
}
